
export function getWorkspaceNotifications (state) {
  return state.workspaceNotifications.data
}



// WEBPACK FOOTER //
// ./selectors/workspace-notifications.js